<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">Inspired by:</p>
<p style="text-align: center;">Woolly, the Old English Sheepdog</p>
<p style="text-align: center;">Fido, the mongrel</p>
<p style="text-align: center;">Melly, the mongrel</p>
<p style="text-align: center;">Tyson, the German Shepherd</p>
<p style="text-align: center;">Barcelona, the Great Dane</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?9b1f4518